export default function getIsCurrentGroupOrganization(state: any) {
  return state.getIn(['currentGroup', 'data', 'type']) === 3;
}
